<div class="as-supermix-container">
  <div class="as-top-container">
    <div class="as-header-container">
      <p class="as-header">Súper Mix <span class='as-promo'>{{this.promo}}</span></p>
      <mat-icon
        (click)="closeModal()"
        class="as-pointer"
        svgIcon="ic-close-gray"
      >
      </mat-icon>
    </div>
    <p class="as-title">{{ product?.event_name | titlecase }}</p>
  </div>

  <div class="as-products-container">
    @for (product of product?.super_mix; track product) {
    <app-product-card [product]="product"></app-product-card>
    }
  </div>
</div>
